import usePageProps from 'app/components/hooks/usePageProps';
import Layout from 'app/components/Layouts/Layout'
import { MODALS } from 'app/components/Layouts/Modals';
import { UserType } from 'app/components/Types/UserType';
import ColumnGraph from 'app/fragments/ColumnGraph'
import IconText from 'app/fragments/IconText';
import React from 'react'

interface Props { }

function Index(props: Props) {
    const { } = props

    const { user } = usePageProps<{ user: UserType }>();

    return (
        <Layout heading="Dashboard" withoutPadding>
            <div className="flex justify-between mt-40px px-30px">
                <h2 className="text-24 font-bold">Hi {user.name},</h2>
                <div>
                    <div></div>
                    {/* <a className="cursor-pointer" onClick={() => open(MODALS.NEWTASK)}><IconText className="bg-green-539648 text-white py-12px px-16px rounded-full text-16 font-medium" icon="plus" text="Add Task" /></a> */}
                </div>
            </div>
            <div className=" mt-16px px-30px text-16 text-[#CCCCCC]">
                look at all these stats, <span className='font-bold'>aren't they beautiful?</span>.
            </div>
            
            <ColumnGraph user={user} />
        </Layout>
    )
}

export default Index
